import React from 'react';
import PropTypes from 'prop-types';

import StaticPage from 'src/common/StaticPage/StaticPage';
import Footer from 'src/terminal/components/Footer';
import SubHeader from 'src/terminal/components/SubHeader';

const TerminalStaticPageSubHeader = ({ contextData }) => {
  const props = {};

  if (contextData?.currentPage?.meta_title) {
    props.pageName = contextData.currentPage.meta_title;
  }

  return <SubHeader isStaticPage {...props} />;
};

const TerminalStaticPage = props => (
  <StaticPage CustomFooter={Footer} CustomHeader={TerminalStaticPageSubHeader} {...props} />
);

TerminalStaticPage.propTypes = {
  contextData: PropTypes.object,
};

export default TerminalStaticPage;
